import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
//import { DataTableDirective } from 'angular-datatables';
import { Subject, Subscription } from 'rxjs';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { Router, NavigationExtras } from '@angular/router';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ExportgridComponent } from '../grid/exportgrid/exportgrid.component';
@Component({
  selector: 'app-defaultledger',
  templateUrl: './defaultledger.component.html',
  styleUrls: ['./defaultledger.component.css']
})
export class DefaultledgerComponent implements OnInit, AfterViewInit, OnDestroy {



  defaultaccountColl: any = [];
  branchColl: any = [];
  accountColl: any = [];

  isadd: boolean = false;
  isedit: boolean = false;
  isdelete: boolean = false;
  isview: boolean = false;
  isprint: boolean = false;
  isexport: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Defaultledger";

  branchid: number = null;
  accountid: number = null;
  defaultaccountid: number = null;

  defaultaccountgroupid: number = null;

  _routerLoginSub = Subscription.EMPTY;
  _routerParamsSub = Subscription.EMPTY;

  constructor(private appService: DhukanDataService, public router: Router,
    private confirmationDialogService: ConfirmationDialogService, private toastr: ToastrService, private loginService: LoginDataService) { this.fnServiceChanges(); }

  //User Check
  fnServiceChanges() {
    this._routerLoginSub = this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          this.fnCheckPrivilage();
          if (this.isview) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }


  ngOnInit() {
    try {


      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          this.fnCheckPrivilage();
          if (this.isview) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {

    this.fngetBranch();
    this.fngetAccount();
  }

  fnCheckPrivilage() {

    this.isadd = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE');
    this.isedit = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER');
    this.isdelete = this.loginService.fnCheckUserRoleAction(this.formname, 'DELETE');
    this.isview = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW');
    this.isprint = this.loginService.fnCheckUserRoleAction(this.formname, 'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  ngAfterViewInit(): void {

  }

  ngOnDestroy(): void {
    if (this._routerLoginSub !== undefined) {
      this._routerLoginSub.unsubscribe();
    }
    if (this._routerParamsSub !== undefined) {
      this._routerParamsSub.unsubscribe();
    }

  }

  fngetBranch() {
    var data = {
      'branchid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getBranch(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.branchColl = res.json().result;
            if (this.branchColl.length > 0) {
              this.branchid = this.branchColl[0].branchid;

              this.fngetDefaultledger();
            }
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fngetAccount() {
    var data = {
      'accountid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getAccount(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.accountColl = res.json().result;

          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fngetDefaultledger() {

    if (this.showProgress) {
      return;
    }

    this.fnShowProgress();
    var data = {
      'branchid': this.branchid,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getDefaultAccount(data)
      .subscribe(
        (res) => {
          console.log(res)
          this.fnHideProgress();
          if (res.json().status == 200) {
            this.defaultaccountColl = res.json().result;

            this.fnSetDataTable();
          }
          else if (res.json().status == 400) {
            this.toastr.error('Error', res.json().err_field);
          }


        },
        (err) => {
          this.fnHideProgress();
          this.toastr.error('Error', err);
        })
  }


  fnSaveBtnClick() {

    for (let row of this.defaultaccountColl) {
      console.log(row)

      row.modifiedby = this.loginService.fnGetModUserId(),
      row.companyid = this.loginService.fnGetCompanyId(),
      row.organizationid = this.loginService.fnGetOrganizationId(),

      this.fnSetDefaultAccountLedger(row);
      this.fnCloseForm();
    }
  }


  fnSetDefaultAccountLedger(data) {

    this.appService.fnSetDefaultAccount(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          if (res.json().result != "") {

          }
        }
        else {
          //this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }




  private fnSetDataTable() {

  }

  fnPrintData() {
    try {


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnExportData() {
    try {


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  fnGetDescription(id) {
    const index = this.defaultaccountColl.findIndex(sku => sku.branchid === id);

    if (index) {
      return this.defaultaccountColl[index].Defaultledgerid;
    }
    else {
      return "";
    }

  }
  public fnSearchDatatable(value) {



  }

  fnCloseForm() {
    try {
      this.router.navigate(['/Configration']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),
      }


      // this.appService.fnInsertActivity(data).subscribe(
      //   (res)=>{
      //   },
      //   (err)=>{

      //   });

    } catch {

    }
  }



  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }




}
